/* Craftybella PDP — add to cart / buy now + missing-details prompt.
   Loads after cb-pdp.js and registers itself on CB.mods. */
window.CB = window.CB || {};
(function (CB) {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function toast(m) { if (CB.toast) CB.toast(m); }
  function addToCart(items) { return CB.addToCart(items); }
  function refreshCartCount() { return CB.refreshCartCount ? CB.refreshCartCount() : null; }

  function productForm(root) {
    var form = $('[data-cb-form]', root);
    if (!form) return;
    var nudge = $('[data-cb-nudge]', root);
    var noteEl = $('[data-cb-note]', root);
    var nameEl = $('[data-cb-name]', root);

    function payload() {
      var fd = new FormData(form);
      var props = {};
      fd.forEach(function (v, k) {
        var m = k.match(/^properties\[(.+)\]$/);
        if (m && String(v).trim() !== '') props[m[1]] = v;
      });
      var item = { id: fd.get('id'), quantity: parseInt(fd.get('quantity'), 10) || 1 };
      if (Object.keys(props).length) item.properties = props;
      return item;
    }

    function hasFiles() {
      var fs = form.querySelectorAll('input[type="file"]');
      for (var i = 0; i < fs.length; i++) {
        if (fs[i].files && fs[i].files.length) return true;
      }
      return false;
    }

    function submit(buyNow) {
      var btn = buyNow ? $('[data-cb-buy]', root) : $('[data-cb-add]', root);
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      /* /cart/add.js cannot carry an uploaded file. When the customer has
         attached photos we hand the browser the real multipart POST instead,
         which lands on /cart with the files stored against the line item. */
      if (hasFiles()) {
        if ($('[data-cb-state="busy"]', root)) {
          if (btn) { btn.disabled = false; btn.innerHTML = label; }
          toast('Still preparing your photos \u2014 one moment.');
          return;
        }
        if ($('[data-cb-state="bad"]', root)) {
          if (btn) { btn.disabled = false; btn.innerHTML = label; }
          toast('One photo is too large. Please replace it before adding to cart.');
          return;
        }
        /* Without return_to this POST lands the shopper on /cart. Sending them
           back to the product instead keeps them shopping, and the flag tells
           cb-cart.js to open the drawer once the page comes back. Buy Now is
           the one case that should go to the cart, because Magic Checkout
           only engages from there. */
        var rt = form.querySelector('input[name="return_to"]');
        if (!rt) {
          rt = document.createElement('input');
          rt.type = 'hidden';
          rt.name = 'return_to';
          form.appendChild(rt);
        }
        if (buyNow) {
          rt.value = '/cart';
        } else {
          rt.value = window.location.pathname +
            (window.location.search ? window.location.search + '&' : '?') + 'cb_added=1';
        }
        HTMLFormElement.prototype.submit.call(form);
        return;
      }

      addToCart([payload()])
        .then(function () {
          /* Magic Checkout has buyNowEnabled off and enableMagicBtn false on the PDP,
             so it only engages from the cart. Going straight to /checkout would bypass it. */
          if (buyNow) { window.location.href = '/cart'; return; }
          /* Open the drawer the moment the cart accepts the item. This used to
             wait for the count refresh first, which put another network round
             trip between the click and anything happening on screen -- about
             two seconds of a button that looked stuck. The count still
             refreshes, it just no longer holds the drawer up. */
          if (btn) { btn.disabled = false; btn.innerHTML = label; }
          toast('Added to your cart');
          document.dispatchEvent(new CustomEvent('cb:atc'));
          refreshCartCount();
        })
        .catch(function (e) {
          if (btn) { btn.disabled = false; btn.innerHTML = label; }
          toast(e.message || 'Something went wrong. Please try again.');
        });
    }

    /* ---------- Missing-details prompt ----------
       Whatever the shopper left empty is listed by name in an overlay before
       the item goes in the cart. Two ways out, both final: "fill" closes the
       prompt and puts them on the first empty field, "skip" carries on with
       whatever they clicked — add to cart, or Buy Now — and is remembered for
       the rest of the visit so nobody is asked twice. It is a prompt, never a
       gate: every path still ends in the sale.                               */
    var skipped = false;
    var opener = null;

    function cleanLabel(t) {
      return String(t || '').replace(/\(optional\)/ig, '').replace(/\s+/g, ' ').trim();
    }

    function fieldLabel(el, fallback) {
      var wrap = el.closest ? el.closest('.cb-field') : null;
      var lab = wrap ? $('.cb-field__lab', wrap) : null;
      return cleanLabel(lab && lab.textContent) || fallback;
    }

    function boxOf(el) {
      return (el.closest && (el.closest('.cb-photo') || el.closest('.cb-field'))) || null;
    }

    function missing() {
      var out = [];
      if (nameEl && !nameEl.value.trim()) out.push({ label: fieldLabel(nameEl, 'Name'), el: nameEl });
      if (noteEl && !noteEl.value.trim()) out.push({ label: fieldLabel(noteEl, 'Personalised note'), el: noteEl });
      $$('[data-cb-photo]', root).forEach(function (inp, i) {
        if (!inp.files || !inp.files.length) out.push({ label: 'Photo ' + (i + 1), el: inp });
      });
      return out;
    }

    function onNudgeKey(e) {
      if (e.key === 'Escape') { closeNudge(); return; }
      if (e.key !== 'Tab' || !nudge) return;
      var f = $$('button', nudge).filter(function (b) { return b.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function closeNudge() {
      if (!nudge || nudge.hidden) return;
      nudge.hidden = true;
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onNudgeKey);
      if (opener && opener.focus) {
        try { opener.focus({ preventScroll: true }); } catch (e) { opener.focus(); }
      }
    }

    function openNudge(list, buyNow) {
      var ul = $('[data-cb-nudge-list]', nudge);
      if (ul) {
        ul.innerHTML = '';
        list.forEach(function (m) {
          var li = document.createElement('li');
          li.textContent = m.label;
          ul.appendChild(li);
        });
      }
      nudge.setAttribute('data-cb-pending', buyNow ? 'buy' : 'add');
      nudge.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', onNudgeKey);
      var w = $('[data-cb-nudge-write]', nudge);
      if (w) setTimeout(function () { w.focus(); }, 30);
    }

    function attempt(buyNow, from) {
      opener = from || null;
      if (nudge && !skipped) {
        var list = missing();
        if (list.length) { openNudge(list, buyNow); return; }
      }
      submit(buyNow);
    }

    /* expose for the bought-together block, which lives in its own section */
    window.__cbMainPayload = payload;

    var add = $('[data-cb-add]', root), buy = $('[data-cb-buy]', root);
    if (add) add.addEventListener('click', function (e) { e.preventDefault(); attempt(false, add); });
    if (buy) buy.addEventListener('click', function (e) { e.preventDefault(); attempt(true, buy); });
    form.addEventListener('submit', function (e) { e.preventDefault(); attempt(false, add); });

    if (nudge) {
      $$('[data-cb-nudge-close]', nudge).forEach(function (b) {
        b.addEventListener('click', closeNudge);
      });

      var skipBtn = $('[data-cb-nudge-skip]', nudge);
      var writeBtn = $('[data-cb-nudge-write]', nudge);

      if (skipBtn) skipBtn.addEventListener('click', function () {
        skipped = true;
        var buyNow = nudge.getAttribute('data-cb-pending') === 'buy';
        closeNudge();
        submit(buyNow);
      });

      if (writeBtn) writeBtn.addEventListener('click', function () {
        var list = missing();
        closeNudge();
        $$('.is-missing', root).forEach(function (el) { el.classList.remove('is-missing'); });
        list.forEach(function (m) {
          var box = boxOf(m.el);
          if (box) box.classList.add('is-missing');
        });
        var first = list[0];
        if (!first) return;
        (boxOf(first.el) || first.el).scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (first.el.type !== 'file') {
          setTimeout(function () {
            try { first.el.focus({ preventScroll: true }); } catch (e) { first.el.focus(); }
          }, 340);
        }
      });

      /* drop the highlight the moment a field is filled */
      [nameEl, noteEl].concat($$('[data-cb-photo]', root)).forEach(function (el) {
        if (!el) return;
        el.addEventListener(el.type === 'file' ? 'change' : 'input', function () {
          var box = boxOf(el);
          if (box) box.classList.remove('is-missing');
        });
      });
    }

    /* sticky bar buttons mirror the main ones */
    var sAdd = $('[data-cb-sticky-add]'), sBuy = $('[data-cb-sticky-buy]');
    if (sAdd) sAdd.addEventListener('click', function (e) { e.preventDefault(); attempt(false, sAdd); });
    if (sBuy) sBuy.addEventListener('click', function (e) { e.preventDefault(); attempt(true, sBuy); });
  }

  /* Deferred scripts run after the document is parsed, so cb-pdp.js may already
     have finished its own init by the time this file executes. Boot ourselves
     instead of relying on load order; the guard keeps it to once per block. */
  function boot() {
    $$('[data-cb-pdp]').forEach(function (root) {
      if (root.__cbForm) return;
      root.__cbForm = true;
      try { productForm(root); } catch (e) {}
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})(window.CB);
